document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[id^="countdown-"]').forEach(section => {
    const settings = JSON.parse(section.getAttribute('data-settings') || '{}');

    // Construye la fecha objetivo
    const dateStr = settings.target_date;   // expects "YYYY-MM-DD"
    const timeStr = settings.target_time;   // expects "HH:MM:SS"
    const targetTimestamp = new Date(`${dateStr}T${timeStr}`).getTime();
    const expiredMsg = settings.message_expired || '¡La oferta ha finalizado!';

    // Aplica colores vía CSS variables
    section.style.setProperty('--countdown-number-color', settings.number_color);
    section.style.setProperty('--countdown-label-color', settings.label_color);

    function updateTimer() {
      const now  = Date.now();
      const diff = targetTimestamp - now;

      if (diff <= 0) {
        section.innerHTML = `<div class="countdown-expired">${expiredMsg}</div>`;
        clearInterval(intervalId);
        return;
      }

      const days    = Math.floor(diff / 86400000);
      const hours   = Math.floor((diff % 86400000) / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);

      section.querySelector('[data-unit="days"]').textContent    = String(days).padStart(2, '0');
      section.querySelector('[data-unit="hours"]').textContent   = String(hours).padStart(2, '0');
      section.querySelector('[data-unit="minutes"]').textContent = String(minutes).padStart(2, '0');
      section.querySelector('[data-unit="seconds"]').textContent = String(seconds).padStart(2, '0');
    }

    updateTimer();
    const intervalId = setInterval(updateTimer, 1000);
  });
});
